export default __webpack_public_path__ + "static/media/apple.00c33cf4.svg";